import React, { useState } from "react"
import { PaginatedSearchPayload } from "../../state/search/SearchPayload"
import Pagination from "../listing/pagination.component"

const DEFAULT_PAGE_SIZE = 25

const useListingPagination = (params: Partial<PaginatedSearchPayload>) => {
    const [paginatedSearch, setPaginatedSearch] = useState<PaginatedSearchPayload>( {
        keywords: params.keywords ?? "",
        activePage: params.activePage ?? 1,
        pageSize: params.pageSize ?? DEFAULT_PAGE_SIZE,
        sortByField: params.sortByField ?? "createdAt",
        sortAsc: params.sortAsc ?? true,
        filters:params.filters??{},
    })
    const [totalItemsCount, setTotalItemsCount] = useState<number>(0)

    const handleKeywordsChange = (searchKeywords: string) => {
        setPaginatedSearch(current => {
            return {
                ...current,
                activePage: 1,
                keywords: searchKeywords,
            }
        })
    }

    const handlePageChange = (activePage: number) => {
        setPaginatedSearch(current => {
            return {
                ...current,
                activePage: activePage,
            }
        })
    }

    const handlePageSizeChange = (pageSize: number) => {
        const isPastLastPage = pageSize * paginatedSearch.activePage > totalItemsCount
        const updatedPaginatedSearch = {
            activePage: isPastLastPage ? 1 : paginatedSearch.activePage,
            pageSize: pageSize,
        }

        setPaginatedSearch(current => {
            return {
                ...current,
                ...updatedPaginatedSearch
            }
        })
    }

    const handleSorting = (sortByField: string, asc: boolean) => {
        setPaginatedSearch({
            ...paginatedSearch,
            sortByField: sortByField,
            sortAsc: asc,
        })
    }

    const updateTotalItemsCount = (newTotalItemsCount: number) => {
        if (newTotalItemsCount != totalItemsCount) {
            setTotalItemsCount(newTotalItemsCount)
        }
    }

    const pagination = () => {
        return <Pagination
            className={"px-2"}
            activePage={paginatedSearch.activePage}
            pageSize={paginatedSearch.pageSize}
            showPageSize={true}
            totalItemsCount={totalItemsCount}
            onChange={handlePageChange}
            onPageSizeChange={handlePageSizeChange}
        />
    }

    return {
        paginatedSearch,
        handlePageChange,
        handleSorting,
        handleKeywordsChange,
        updateTotalItemsCount,
        pagination
    }
}

export default useListingPagination



// WEBPACK FOOTER //
// ./src/common/hooks/UseListingPagination.tsx